import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en/lang'
import ja from './ja/lang'
import rtc from './_report/tc/lang'
import ren from './_report/en/lang'
import rja from './_report/ja/lang'
import lrtc from './_labReport/tc/lang'
import lren from './_labReport/en/lang'
import lrja from './_labReport/ja/lang'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'tc'

const i18n = new VueI18n({
  locale,
  messages: {
    en,
    ja,
    rtc,
    ren,
    rja,
    lrtc,
    lren,
    lrja
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/constants/lang/i18n.js